import React from 'react';
import './HamburgerMenu.css';
import { useTranslation } from '../../i18n/LanguageContext';

interface MenuItem {
  id: string;
  label: string;
  icon?: string;
  action: () => void;
}

interface HamburgerMenuProps {
  menuOpen: boolean;
  onClose: () => void;
  onSystemSettings?: () => void;
  onRestSettings?: () => void;
  onAppInfo?: () => void;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ 
  menuOpen,
  onClose,
  onSystemSettings,
  onRestSettings,
  onAppInfo
}) => {
  const { t } = useTranslation();
  
  if (!menuOpen) return null;

  const menuItems: MenuItem[] = [
    {
      id: 'system-settings',
      label: t('menu.systemSettings'),
      icon: '⚙️',
      action: () => {
        onSystemSettings?.();
        onClose();
      }
    },
    {
      id: 'rest-settings',
      label: t('menu.restSettings'),
      icon: '😴',
      action: () => {
        onRestSettings?.();
        onClose();
      }
    },
    {
      id: 'app-info',
      label: t('menu.appInfo'),
      icon: 'ℹ️',
      action: () => {
        onAppInfo?.();
        onClose();
      }
    }
  ];

  return (
    <div 
      className="hamburger-menu-overlay"
      onClick={onClose}
    >
      <div 
        className="hamburger-menu-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="menu-items">
          {menuItems.map(item => (
            <button
              key={item.id}
              className="menu-item"
              onClick={item.action}
            >
              <span className="menu-item-icon">{item.icon}</span>
              <span className="menu-item-label">{item.label}</span>
              <span className="menu-item-arrow">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;